import { Route } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../app.constants';

import { UserRouteAccessService } from '../shared';
import { FaqComponent } from './faq.component';

export const faqRoute: Route = {
  path: 'faq',
  component: FaqComponent,
  data: {
    needAuthentication: false,
    pageTitle: `Aide${PAGE_TITLE_SUFFIX}`
  },
  canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/faq/faq.route.ts